import isEmpty from "lodash/isEmpty";
import constans from "../Common/Constants";
import Config from "../Common/Config";
import Functions from "../Common/Functions";
import isEqual from "lodash/isEqual";
import { intersection } from "lodash";
import { polygonStartString, selectedPolygonTypes } from "../Common/Constants";
import { havePermission } from "../../permissions";
import LAYER_PERMISSIONS from "../../permissions/Layers.json";
const { SecColors } = constans;
const { getLegend } = Functions;
const { SEC } = Config;
const TRANSPARENT = "#FFFFFF11";

const { SecPolgons: SecPolygonStartKey } = selectedPolygonTypes;
const getSecLegends = ({ data, legendHandler, tenant }) => {
	if (!havePermission(LAYER_PERMISSIONS.LAYER_SHOPPER_PROFILE_LEGEND)) return {};

	const legends = [];
	let allSec = SEC[tenant] || [];

	if (isEmpty(allSec) && !isEmpty(data)) {
		allSec = getAllSecs({ data });
		if (isEmpty(allSec)) {
			return { legends: [] };
		}
	}
	//sort alll sec from a to z
	allSec.sort((a, b) => a.localeCompare(b));
	allSec.forEach(value => {
		legends.push(
			getLegend({
				text: `SEC ${value}`,
				color: SecColors[value],
				onClick: () => {
					legendHandler(value);
				}
			})
		);
	});
	return { legends };
};

const getAllSecs = ({ data }) => {
	if (isEmpty(data)) return [];
	let allSecs = [];
	if (Array.isArray(data))
		for (let polygon of data) {
			const { sec } = polygon;
			if (!allSecs.includes(sec)) allSecs.push(sec);
		}
	allSecs = Array.from(new Set([...allSecs]));
	if (!isEqual(intersection(allSecs, Object.keys(SecColors)), allSecs)) {
		// toast.error("SECs are not in the same order as the SEC colors");
		return [];
	} else return allSecs;
};

const buildSecPolygonsAndLegend = ({ analysisData, filter }) => {
	try {
		let polygons = {};
		if (!isEmpty(analysisData)) {
			for (let [ind, secRow] of analysisData.entries()) {
				ind = `${polygonStartString[SecPolygonStartKey]}${ind}`;
				let { sec, coordinates } = secRow;
				let fillColor = TRANSPARENT;
				if (!isEmpty(filter)) {
					if (filter === sec) fillColor = SecColors[filter] ?? TRANSPARENT;
				} else {
					fillColor = SecColors[sec];
				}

				let polygon = {
					id: ind,
					coordinates: coordinates,
					style: {
						fillColor: fillColor,
						strokeColor: fillColor,
						zIndex: 11
					},
					marker: coordinates[0],
					filterData: {
						value: sec
					},
					sec: sec,
					showInfo: false
				};
				polygons[ind] = polygon;
			}
		}

		return { polygons }; //graphData: Object.values(graphData)
	} catch (err) {
		console.error(err);
	}
};

const SecPolgons = {
	all: ({ data, tenant, legendHandler }) => {
		return {
			...getSecLegends({ data, legendHandler, tenant }),
			...buildSecPolygonsAndLegend({ analysisData: data, filter: "", tenant })
		};
	}
};
export default SecPolgons;
